/**
 * SherpaProjectTemplateTDMImportShell - Shell component for Sherpa TDM CSV Import
 *
 * This component wraps the TDM import functionality for Sherpa routes.
 * Since the ReviewContents component has embedded API calls, we use it directly here.
 * Future refactoring can extract those calls to this shell.
 */

import { ArrowUpTrayIcon } from '@heroicons/react/24/solid';
import { useState } from 'react';
import Button from '@/components/UI/Button';
import { CSVParserProvider } from '@/store/Context/CSVParserContext';
import { ReviewContents } from '../../Components/ProjectTemplateDetails/ProjectTemplateTDMImport/ReviewContents';
import { UploadModal } from '../../Components/ProjectTemplateDetails/ProjectTemplateTDMImport/UploadModal';

export const SherpaProjectTemplateTDMImportShell = () => {
  const [showUploadModal, setShowUploadModal] = useState<boolean>(false);

  const toggleModal = () => {
    setShowUploadModal((prev) => !prev);
  };

  return (
    <CSVParserProvider>
      <Button btnStyle='btn-primary' type='button' label='Import from CSV' icon={<ArrowUpTrayIcon />} onClick={toggleModal} />
      <ReviewContents />
      {showUploadModal && <UploadModal onHide={toggleModal} />}
    </CSVParserProvider>
  );
};

export default SherpaProjectTemplateTDMImportShell;
